import { deleteObj } from "../core";
import type { DrawingModule } from "../types/DrawingWeb";
import type { Point3D } from "../transform/types";

/**
 * Changes the scale of BlockReference to values
 * @param blockRef
 * @param module
 * @param newScaleX
 * @param newScaleY
 * @param newScaleZ
 */
export function applyScales2D(
  module: typeof DrawingModule,
  blockRef: DrawingModule.OdDbBlockReference,
  newScaleX: number,
  newScaleY: number,
  newScaleZ: number,
) {
  const newScale = new module.OdGeScale3d(newScaleX, newScaleY, newScaleZ);
  blockRef.setScaleFactors(newScale);
  deleteObj(newScale);
}

/**
 * Apply a delta to current scale
 * @param blockRef
 * @param module
 * @param deltaScaleX
 * @param deltaScaleY
 * @param deltaScaleZ
 */
export function applyDelta2Scale2D(
  module: typeof DrawingModule,
  blockRef: DrawingModule.OdDbBlockReference,
  deltaScaleX: number,
  deltaScaleY: number,
) {
  const currentScale = blockRef.scaleFactors();

  // Calculate new scale factors (uniform scaling on X and Y)
  const newScaleX = currentScale.sx * deltaScaleX;
  const newScaleY = currentScale.sy * deltaScaleY;
  const newScaleZ = currentScale.sz; // Keep Z unchanged for 2D

  applyScales2D(module, blockRef, newScaleX, newScaleY, newScaleZ);

  deleteObj(currentScale);
}

export function applyDeltaScaleWithAnchorPoint(
  module: typeof DrawingModule,
  blockRef: DrawingModule.OdDbBlockReference,
  anchorPoint: Point3D,
  deltaScaleX: number,
  deltaScaleY: number,
) {
  applyDelta2Scale2D(module, blockRef, deltaScaleX, deltaScaleY);

  const position = blockRef.position();

  // Calculate position adjustment to maintain anchor point
  const offsetX = (position.x - anchorPoint.x) * (deltaScaleX - 1);
  const offsetY = (position.y - anchorPoint.y) * (deltaScaleY - 1);

  const newPosition = new module.OdGePoint3d(
    position.x + offsetX,
    position.y + offsetY,
    position.z,
  );
  blockRef.setPosition(newPosition);

  deleteObj(position);
  deleteObj(newPosition);
}
